import { ChatUI } from '@voxityai/chat-ui';
import { auth } from '@actions/services/firestore/browser/firebase';
import useChatOrganization from './hooks/useChatOrganization';
import useUserViewContext from '../UserViewContext/hooks/useUserViewContext';
import getChatNamespace from './helpers/getChatNamespace';
import WebappChatUIErrorBoundary from './WebappChatUIErrorBoundary';
import useChatEffects from './chatEffects';
import type { WebappChatUIComponent, WebappChatUIProps } from './types';

const ChatUIWithOnEvent = ChatUI as unknown as WebappChatUIComponent;

const WebappChatUI = (_props: WebappChatUIProps) => {
    const { organizationId } = useChatOrganization();
    const { userViewContext } = useUserViewContext();
    const handleChatEvent = useChatEffects({});
    const server = import.meta.env.VITE_ACTIONS_BASE_URL || 'http://localhost:8080';
    const widgetUrl = import.meta.env.VITE_CHAT_UI_WIDGET_URL;
    const namespace = getChatNamespace({
        namespaceFromUserViewContext: userViewContext.ids.namespace,
    });
    if (!organizationId) {
        return null;
    }

    return (
        <WebappChatUIErrorBoundary>
            <ChatUIWithOnEvent
                auth={auth}
                server={server}
                namespace={namespace}
                organizationId={organizationId}
                userViewContext={userViewContext}
                widgetUrl={widgetUrl}
                onEvent={handleChatEvent}
            />
        </WebappChatUIErrorBoundary>
    );
};

export default WebappChatUI;
